export default __webpack_public_path__ + "static/VisionZero-16502d1df7d21f4394efaa810775bbfc.png";